import { WidgetHeaderAction } from '@agilox/common';
import {
	ButtonComponent,
	DropdownDirective,
	DropdownModule,
	IconModule,
	TagComponent,
	TooltipModule,
} from '@agilox/ui';
import { AsyncPipe } from '@angular/common';
import { Component, input, viewChild } from '@angular/core';

@Component({
	selector: 'ui-widget-header',
	templateUrl: './widget-header.component.html',
	imports: [DropdownModule, IconModule, TooltipModule, ButtonComponent, AsyncPipe, TagComponent],
})
export class WidgetHeaderComponent<K> {
	title = input<string>();
	actions = input<WidgetHeaderAction<K>[]>([]);
	beta = input<boolean>(false);
	showIconsOnDesktop = input<boolean>(true);
	truncateTitle = input<boolean>(false);

	dropdown = viewChild<DropdownDirective | undefined>(DropdownDirective);

	onActionClick(actionKey: K) {
		const activeAction = this.actions()?.find((a) => a.key === actionKey);
		if (!activeAction) {
			return;
		}

		if (activeAction.onClick) {
			activeAction.onClick();
			this.dropdown()?.closeDropdown();
		}
	}
}
